import dayjs from 'dayjs'

import { dateDMYHHMMSSToDate, dateDMYToDate } from '../../../utils/dayjsHelper'
import { genReplaceEmpty } from '../../../utils/helper'
import { LoteApiInputProps, LoteInputProps, LoteProps } from '../../../interfaces/lote.ts'

export const loteActualizarComposeService = (input: LoteProps): LoteInputProps => {
  return {
    codigoLote: input.codigoLote,
    descripcion: input.descripcion,
    fechaAdmision: dateDMYHHMMSSToDate(input.fechaAdmision as any)! as any,
    fechaFabricacion: dateDMYToDate(input.fechaFabricacion)!,
    fechaVencimiento: dateDMYToDate(input.fechaVencimiento)!,
    atributo1: genReplaceEmpty(input.atributo1, ''),
    atributo2: genReplaceEmpty(input.atributo2, ''),
    codigoArticulo: input.codigoArticulo,
  }
}

/**
 * Solo es parte de la llamada a la api
 * @param input
 */
export const loteActualizarToApiCompose = (input: LoteInputProps): LoteApiInputProps => {
  return {
    descripcion: input.descripcion,
    fechaAdmision: dayjs(input.fechaAdmision).format('DD/MM/YYYY HH:mm:ss').toString(),
    fechaFabricacion: dayjs(input.fechaFabricacion).format('DD/MM/YYYY').toString(),
    fechaVencimiento: dayjs(input.fechaVencimiento).format('DD/MM/YYYY').toString(),
    atributo1: input.atributo1,
    atributo2: input.atributo2,
  }
}
